import { Component, Input, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lms-list-row-detail',
  templateUrl: './list-row-detail.component.html',
  styleUrls: ['./list-row-detail.component.scss'],
  animations: [
    trigger('detailState', [
      state(
        'visible',
        style({
          maxHeight: '10000px',
          opacity: 1,
          padding: '*',
          margin: '*'
        })
      ),
      state(
        'hidden',
        style({
          maxHeight: '0',
          opacity: 0,
          padding: 0,
          margin: 0
        })
      ),
      transition('hidden => visible', animate('300ms ease-in-out')),
      transition('visible => hidden', [style({ padding: '*', margin: '*' }), animate('300ms ease-in-out')])
    ])
  ]
})
export class ListRowDetailComponent implements OnInit {
  public visible: boolean;

  constructor() {}

  ngOnInit() {}

  toggleState() {
    this.visible = !this.visible;
  }
}
